// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--Tq_us{0%{background-position:200% 0}100%{background-position:-200% 0}}.drag-handle{cursor:col-resize !important;background-color:rgba(0,0,0,0);border:none}.drag-handle .visual-bar{background-color:#16c2d5;border-radius:4px;margin-right:3px;margin-left:3px}.drag-handle br{display:none}.timing-mode .drag-handle .visual-bar{background-color:#db8200}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shimmer-loading": "shimmer-loading--Tq_us"
};
export default ___CSS_LOADER_EXPORT___;
